import { conditionMethods as coreConditionMethods } from 'js/components/system/TagManager/components/Tags/components/Tag/helpers';
import { CONDITION_TYPE_BUZZ } from '@interlayer/js/components/system/TagManager/buzz/constants';

export * from 'js/components/system/TagManager/components/Tags/components/Tag/helpers';

export const conditionMethods = {
    ...coreConditionMethods,
    [CONDITION_TYPE_BUZZ.excludePage]: ({ config }, data) => {
        const { excludePages } = config;
        const { page } = data;
        const pages = excludePages
            .trim()
            .split(/(?:\s|,)\s*/)
            .filter(Boolean);

        return !pages.includes(page);
    }
};

export const runCondition = (condition, data) => {
    const fn = conditionMethods[condition.conditionTypeId];

    if (fn) {
        return fn(condition, data);
    }
};

export const checkCondition = (trigger, regular, additional) => {
    const { type, data } = trigger;
    const condByType = regular.filter(item => item.conditionTypeId === type);

    return condByType.some((item) => {
        const fn = () => runCondition(item, data);
        const addFns = additional.map(item2 => () => runCondition(item2, data));

        return [fn, ...addFns].every(f => f());
    });
};

